import { render } from "./ApresentarNivelPlanoContas.vue?vue&type=template&id=7a74856a&scoped=true&ts=true"
import script from "./ApresentarNivelPlanoContas.vue?vue&type=script&lang=ts"
export * from "./ApresentarNivelPlanoContas.vue?vue&type=script&lang=ts"

import "./ApresentarNivelPlanoContas.vue?vue&type=style&index=0&id=7a74856a&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a74856a"]])

export default __exports__